import React, { useState } from "react";
import { comparisonsData } from "../data/comparisonsData";
import { Scale } from "lucide-react";
import "../styles/aiTools.css"; // Reuse styling variables

export default function AIToolsCompare() {
  const [selectedPair, setSelectedPair] = useState(comparisonsData[0]);

  return (
    <div className="compare-section">
      <div className="compare-nav">
        {comparisonsData.map((pair) => (
          <button
            key={pair.id}
            className={`compare-tab-btn ${selectedPair.id === pair.id ? "active" : ""}`}
            onClick={() => setSelectedPair(pair)}
          >
            {pair.category}: {pair.toolA.name} vs {pair.toolB.name}
          </button>
        ))}
      </div>

      <div className="comparison-grid">
        {/* Tool A */}
        <div className="compare-card side-a">
          <div className="compare-card-header">
            <Scale className="compare-icon" />
            <h3>{selectedPair.toolA.name}</h3>
            <span className="compare-badge">{selectedPair.toolA.developer}</span>
          </div>
          <div className="compare-card-body">
            <div className="compare-row">
              <span className="row-label">Pricing:</span>
              <span className="row-value">{selectedPair.toolA.pricing}</span>
            </div>
            <div className="compare-row">
              <span className="row-label">Accuracy Score:</span>
              <span className="row-value highlight">{selectedPair.toolA.accuracy}</span>
            </div>
            <div className="compare-row">
              <span className="row-label">Best For:</span>
              <span className="row-value">{selectedPair.toolA.bestFor}</span>
            </div>
            <div className="compare-row">
              <span className="row-label">Limitations:</span>
              <span className="row-value limit">{selectedPair.toolA.limitations}</span>
            </div>
          </div>
        </div>

        {/* VS Divider */}
        <div className="vs-divider">VS</div>

        {/* Tool B */}
        <div className="compare-card side-b">
          <div className="compare-card-header">
            <Scale className="compare-icon" />
            <h3>{selectedPair.toolB.name}</h3>
            <span className="compare-badge">{selectedPair.toolB.developer}</span>
          </div>
          <div className="compare-card-body">
            <div className="compare-row">
              <span className="row-label">Pricing:</span>
              <span className="row-value">{selectedPair.toolB.pricing}</span>
            </div>
            <div className="compare-row">
              <span className="row-label">Accuracy Score:</span>
              <span className="row-value highlight">{selectedPair.toolB.accuracy}</span>
            </div>
            <div className="compare-row">
              <span className="row-label">Best For:</span>
              <span className="row-value">{selectedPair.toolB.bestFor}</span>
            </div>
            <div className="compare-row">
              <span className="row-label">Limitations:</span>
              <span className="row-value limit">{selectedPair.toolB.limitations}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
